"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MERGE_ERROR = function (offender, suggestion) {
    if (suggestion === void 0) { suggestion = ''; }
    return "Unknown property \"" + offender + "\"" + (suggestion ? ". Did you mean \"" + suggestion + "\"?" : '');
};
exports.TYPE_ERROR_TARGET = function (target) {
    return "[Helpful Merge] Target \"" + target + "\" must be a valid object";
};
exports.TYPE_ERROR_SOURCE = function (source) {
    return "[Helpful Merge] Source \"" + source + "\" must be a valid object";
};
exports.INVALID_ARRAY_STRATEGY = function (strategy) {
    return "[Helpful Merge] Invalid array strategy \"" + strategy + "\"";
};
//# sourceMappingURL=Messages.js.map